import img1 from './../assets/project1_ss.png'
import img2 from './../assets/project2_ss.png'
import img3 from './../assets/project3_ss.png'
import img4 from './../assets/project4_ss.png'
import img5 from './../assets/project5_ss.jpeg'
import img6 from './../assets/project6_ss.png'
import img7 from './../assets/project7_ss.png'
import img8 from './../assets/project8_ss.jpeg'

export default [
  {
    id: '8',
    title: "Mentor",
    description: "A Responsive Website that guides you via quotes based on your current state of mind.",
    image: img8,
    link: 'https://all-mentor.onrender.com/'
  },
  {
    id: '1',
    title: "Product Launch Landing Page",
    description: "A Responsive Landing Page built using React.js,",
    image: img5,
    link: 'https://aniketnshukla0productlaunch.netlify.app/'
  },
  {
    id: '5',
    title: "Turbo",
    description: "A Car Wiki page made using HTML, CSS and Bootstrap",
    image: img1,
    link: 'https://aniketnshukla.github.io/webpage-turbo/'
  },
  {
    id: '7',
    title: "Todo App",
    description: "Todo App using reactjs, persisting data on browser localstorage",
    image: img7,
    link: 'https://aniketnshukla-employeemanagementsystem.netlify.app/'
  },
  {
    id: '3',
    title: "Food Recipe Search",
    description: "Search Recipes of Foods with ingredients you want",
    image: img3,
    link: 'https://search-recipes-aniketnshukla.netlify.app/'
  },
//   {
//     id: '2',
//     title: "Landing page clone",
//     description: "Clone of the Okinawa Scooters Landing Page",
//     image: img2,
//     link: 'https://confident-borg-80fef6.netlify.app/'
//   },
//   {
//     id: '4',
//     title: "Calendar",
//     description: "Calendar with Events",
//     image: img4,
//     link: 'https://unrivaled-nasturtium-2bae48.netlify.app/'
//   },
//   {
//     id: '6',
//     title: "Employee Management System",
//     description: "A management system built using reactjs",
//     image: img6,
//     link: 'https://aniketnshukla-employeemanagementsystem.netlify.app/'
//   }
]
